<template>
  <div class="group container">
    <div v-if="showTestButton">
      <EntryTest :step="3" />
    </div>
    <entry-index :step="3"></entry-index>
    <h3>受講科目選択と宛名確認</h3>
    <div class="alert alert-info">
    お支払い合計額は <span class="h4">{{ $store.getters['entry/dispCharge']}}</span>円（税込）です。</div>
    <validation-observer v-slot="{ handleSubmit, validated, invalid }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group col-12 mt-4">
          <validation-provider rules="required" v-slot="{ errors }" vid="payment">
            <div class="form-row">
              <div class="custom-control custom-radio">
                <input id="rdoPaymentBill" name="rdoPayment" type="radio" class="custom-control-input" value="bill" v-model="$store.state.entry.payment">
                <label class="custom-control-label" for="rdoPaymentBill"> 払込票によるお支払い</label>
              </div>
              <div class="infoButton">
                <b-button size="sm" variant="info" v-b-modal.modal-bill>詳細</b-button>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label for="txtReceiptName">請求書宛名</label>
                <validation-provider rules="required-if:payment,bill|receipt-name" v-slot="{ errors }">
                  <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtReceiptName" :disabled="!isBill" v-model="$store.state.entry.receipt">
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="text-danger">{{ errors[0] }}</div>
          </validation-provider>
          <label class="h5" for="watchSubject">受講科目</label> <span class="badge badge-danger">必須</span>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="required" v-slot="{ errors }">
                <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" id="selSubject" v-model="$store.state.entry.subject">
                  <option v-for="i in $store.getters.subjectList" :key="i.code" :value="i.code">{{i.name}}</option>
                </select>
              </validation-provider>
            </div>
          </div>
        </div>
        <!-- ナビゲーションボタン -->
        <div class="form-row">
          <div class="col-6">
            <button type="button" class="btn btn-lg btn-default btn-block prev_button" @click="onClickPrev">
              <i class="fas fa-chevron-circle-left"></i>　送付先情報入力へ
            </button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn btn-lg btn-secondary btn-block next_button">
              登録内容の確認へ　<i class="fas fa-chevron-circle-right"></i>
            </button>
            <div class="text-danger" v-if="validated && invalid">入力項目をご確認ください。</div>
          </div>
        </div>
      </form>
    </validation-observer>
    <div>
      <b-modal id="modal-bill" size="xl" title="払込票によるお支払い" ok-only>
        <ul>
          <li>
            <span>ご入力いただいた学校住所宛てに「請求書」「払込票（振込用紙）」とともに「チケット」をお届けします。</span>
          </li>
          <li>
            <span>お受け取り後，払込票にて代金のご入金をお願いいたします。</span><br />
            <span>払込票にてお支払いいただいた場合の手数料は弊社にて負担いたします。</span><br />
            <span>銀行振込によるお支払いの場合，振込手数料をご負担いただきます。</span>
          </li>
        </ul>
      </b-modal>
    </div>
  </div>
</template>

<style lang="scss">
.infoButton {
  margin-left: 1em;
}
</style>

<script>
import EntryIndex from "@/components/EntryIndex.vue"
import EntryTest from "@/components/EntryTest.vue"
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { setInteractionMode } from 'vee-validate'
import { required_if } from  'vee-validate/dist/rules'

setInteractionMode('passive')

extend('required-if', {
  ...required_if,
  message: 'ご入力ください（一部の記号は使用できません）'
})
extend('receipt-name', {
  computesRequired: true,
  validate: (value) => {
    return !value.match(/[&"<>]/)
  },
  message: 'ご入力ください（一部の記号は使用できません）'
})

export default {
  name: "EntryStep1",
  data() {
    return {}
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    EntryIndex,
    EntryTest
  },
  computed: {
    showTestButton() {
      return this.$store.state.showTestButton
    },
    isBill() {
      return this.$store.state.entry.payment == 'bill'
    },
    charge() {
      const count = this.$store.getters['entry/entrantCount']
      return (1000 * count).toLocaleString()
    },
    disableEcol() {
      return this.$store.getters['entry/isRitou']
    }
  },
  methods: {
    onClickPrev() {
      this.$router.back()
    },
    onSubmit() {
      this.$router.push('confirm')
    }
  }
}
</script>